module.exports = __webpack_public_path__ + "static/media/icone_soutienscolaire.baf4efb3.svg";